export default __webpack_public_path__ + "assets/fonts/3c7468952ef6aea60964e756c34c3d46.woff";